<template>
    <div class="distributionListDialog">
        <el-dialog @close='cancel' title="请绑定分销活动" :visible.sync="dialogVisible" width="638px">
                <div class="search_box">
                    <div class="innerbox">
                    </div>
                    <div class="innerbox">
                        <el-select v-model="param.distype" placeholder="分销类型 " class="condition" clearable>
                            <el-option v-for="item in distypeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                        </el-select>
                        <el-select v-model="param.status" placeholder="活动状态" class="condition" clearable>
                            <el-option v-for="item in statusList.slice(0, statusList.length-1)" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                        </el-select>
                        <el-input placeholder="输入活动名称" v-model="param.title" clearable></el-input>
                        <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
                    </div>
                </div>
                <div class="add_goods_tabs_box">
                    <el-table :data="tableData" style="width: 100%" :show-header="false" ref="multipleTable"
                              @select="handleSelectionChange" @row-click="handleRowChange">
                        <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column label="活动名称" min-width="250px">
                        <template slot-scope="scope">
                            <div class="nameBox">
                                <div class="iconBox">
                                    <img :src="scope.row.coveratturlid?scope.row.coveratturlid:imgNoimg" :alt="scope.row.title">
                                </div>
                                <div class="rightBox">
                                    <div class="subject">
                                        <div class="text">{{scope.row.title}}</div>
                                    </div>
                                    <div class="tip">
                                        <span>{{scope.row.templatetypename}}</span>
                                        <span>{{scope.row.distypename}}</span>
                                        <span :class="{'type': true, 'type1': scope.row.resulttype === 1, 'type2': scope.row.resulttype === 2, 'type3': scope.row.resulttype === 3, 'type4': scope.row.resulttype === 4}">{{scope.row.resulttypeText}}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <!--<el-table-column label="价格"  class-name="center" width="80">-->
                        <!--<template slot-scope="scope">￥{{scope.row.saleprice}}</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column label="浏览量"  class-name="center" width="80">-->
                        <!--<template slot-scope="scope">{{scope.row.viewcount?scope.row.viewcount:'-'}}</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column label="销量"  class-name="center" width="80">-->
                        <!--<template slot-scope="scope">{{scope.row.ordersucccount?scope.row.ordersucccount:'-'}}</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column label="销售额"  class-name="center" width="80">-->
                        <!--<template slot-scope="scope">￥{{scope.row.totalincome}}</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column label="状态"  class-name="center" width="80">-->
                        <!--<template slot-scope="scope">-->
                            <!--<div :class="{'ing': scope.row.status === 10}">{{scope.row.statusText}}</div>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                </el-table>
            </div>
            <div class="page" style="margin-top: 15px; text-align: center">
                <el-pagination
                    background
                    @current-change="handleSizeChange"
                    :current-page.sync="page.page"
                    :page-size="page.pageSize"
                    :pager-count="11"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="handleSure">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getDisEventPageList} from 'api/nationalDistribution'
    import {mapGetters, mapActions} from 'vuex'
    import {dateFormat} from 'common/js/tools'
    import {nationalDistribution as nationalDistributionCode} from 'api/enumCode'
    export default {
        name: 'distributionListDialog',
        data() {
            return {
                statusList: nationalDistributionCode.activityStatus,
                distypeList: nationalDistributionCode.distype,
                imgNoimg: require('@/common/images/nationalDistributionMenu/img-noimg.png'),
                param: {
                    status: '',
                    title: '',
                    resulttype: '',
                    templatetype: '',
                    distype: ''
                },
                page: {
                    page: 1,
                    pageSize: 5,
                    pageCount: 0
                },
                total: 0,
                dialogVisible: false,
                tableData: [],
                selectedResult: null
            }
        },
        mounted() {
        },
        methods: {
            handleSure() {
                if (this.selectedResult) {
                    this.$emit('setDisreleventid', this.selectedResult)
                    this.cancel()
                } else {
                    this.$message.error('请选择分销活动')
                }
            },
            handleSelectionChange(selection, row) {
                row.isCheck = !row.isCheck
                this.$refs.multipleTable.clearSelection()
                this.$refs.multipleTable.toggleRowSelection(row, row.isCheck)
                this._changeSelection(row)
            },
            handleRowChange(row) {
                row.isCheck = !row.isCheck
                if (row.isCheck) {
                    this.$refs.multipleTable.clearSelection()
                    this.$refs.multipleTable.toggleRowSelection(row)
                } else {
                    this.$refs.multipleTable.toggleRowSelection(row, false)
                }
                this._changeSelection(row)
            },
            _changeSelection(row) {
                if (row.isCheck) {
                    let obj = {
                        disreleventid: row.innerid,
                        diseventname: row.title,
                    }
                    this.selectedResult = obj
                } else {
                    this.selectedResult = null
                }
            },
            handleQuery() {
                this._getList()
            },
            openDialog(disreleventid, diseventname) {
                this.selectedResult = {
                    disreleventid: disreleventid,
                    diseventname: diseventname,
                }
                this.param.title = ''
                this.dialogVisible = true
                this._getList()
            },
            cancel() {
                this.param.title = ''
                this.page = {
                    page: 1,
                    pageSize: 5,
                    pageCount: 0
                }
                this.selectedResult = null
                this.dialogVisible = false
            },
            handleSizeChange() {
                this._getList()
            },
            _getList() {
                this.setLoading(true)
                getDisEventPageList({
                    data: Object.assign({}, this.param, this.page),
                    success: data => {
                        this.tableData = data.data.content
                        this.$nextTick(() => {
                            if (this.selectedResult.disreleventid) {
                                this.tableData.forEach((obj, i) => {
                                    if (obj.innerid === this.selectedResult.disreleventid) {
                                        obj.isCheck = true
                                        this.$refs.multipleTable.toggleRowSelection(obj, true)
                                        return false
                                    }
                                })
                            }
                        })
                        this.total = data.data.pageinfo.rowCount
                        this.page.pageCount = data.data.pageinfo.pageCount
                        this.setLoading(false)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            },
            ...mapActions([
                'setLoading', 'setBrandBusiness'
            ])
        },
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .distributionListDialog {
        display: flex;
        .search_box{

        }
        .search_box {
            display: flex;
            margin-bottom: 10px;
            justify-content: space-between;
            .innerbox{
                display: flex;
                align-items: center;
            }
            .el-input input{
                width: 196px;
            }
            .el-select{
                width: 124px;
                margin-right: 20px;
                .el-input input{
                    width: 124px;
                }
            }
            .el-input__inner {
                height: 32px;
            }
            .el-input__icon {
                line-height: 32px;
            }
            .el-button,
            .el-button--mini {
                height: 32px;
                width: 96px;
                margin-left: 20px;
                margin-bottom: 0px;
            }
        }
        .add_goods_tabs_box {
            .el-table {
                min-height: 340px;
            }
            .nameBox{
                display: flex;
                .iconBox{
                    min-width: 106px;
                    height: 60px;
                    flex-shrink: 0;
                    flex-grow: 0;
                    margin-right: 10px;
                    img{
                        min-width: 106px;
                        height: 60px;
                    }
                }
                .rightBox{
                    min-width: 104px;
                    display: flex;
                    flex-grow: 1;
                    flex-direction: column;
                    .subject{
                        height: 40px;
                        line-height: 20px;
                        overflow: hidden;
                        .text{
                            font-weight: 600;
                            float: right;
                            /* "margin-left"要等于".wrap::before"的宽度 */
                            margin-left: -10px;
                            width: 100%;
                            word-break: break-all;
                            text-align: left;
                            font-size: 14px;
                            // font-size: 0.48rem;
                        }
                        &::before {
                            float: left;
                            content: '';
                            width: 10px;
                            height: 100%;
                        }
                        &::after {
                            float: right;
                            content: "...";
                            /* 行高与".wrap"设置的一致即可 */
                            height: 40px;
                            line-height: 20px;
                            /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                            width: 37px;
                            margin-left: -37px;
                            /* 移动省略号位置 */
                            position: relative;
                            left: 101.9%;
                            bottom: 20px;
                            font-weight: 600;
                            padding-right: 1px;
                            background: #fff;
                            transition: all 0.5s;
                            text-align: left;
                        }
                    }
                    .tip{
                        font-size: 12px;
                        span+span{
                            margin-left: 10px;
                        }
                    }
                    .type{
                        text-align: left;
                    }
                    .type1{
                        color: #67C23A;
                    }
                    .type2{
                        color: #409EFF;
                    }
                    .type3{
                        color: #E6A23C;
                    }
                    .type4{
                        color:  #F56C6C;
                    }
                }
            }
            .el-table__empty-block {
                height: 340px;
                max-height: 340px;
            }
            .el-table__empty-text {
                position: relative;
                top: 80px;
            }
        }
        .el-table::before {
            height: 0;
        }
        .el-table__header .el-checkbox{
            display: none;
        }
        .dialog-footer{
            margin-top: 0 !important;
        }
    }
</style>
